import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, IconButton } from "@similarweb/ui-components";

export const Wrapper = styled(FlexColumn)`
    color: ${colorsPalettes.carbon[500]};
    align-items: center;
    padding: 16px 24px;
    width: 245px;
`;

export const CloseIconButton = styled(IconButton)`
    position: absolute;
    top: 8px;
    right: 8px;
`;

export const TitleWrapper = styled.div`
    padding-top: 8px;
    padding-bottom: 4px;
    text-align: center;

    ${setFontVariant("listItem1", colorsPalettes.carbon[500])};
`;

export const DescriptionWrapper = styled.div`
    padding-bottom: 16px;
    text-align: center;

    ${setFontVariant("tooltip", colorsPalettes.carbon[500])};
`;
